// Jeu d'icônes maison de la maquette LifeHub : grille 24 px, trait 2 px, extrémités et jointures arrondies,
// couleur `currentColor`. Pas d'emoji ni de caractère unicode en guise d'icône.
const PATHS = {
  plus: 'M12 5v14M5 12h14',
  check: 'M5 12l5 5 9-10',
  close: 'M6 6l12 12M18 6L6 18',
  back: 'M19 12H5M11 6l-6 6 6 6',
  menu: 'M4 7h16M4 12h16M4 17h16',
  down: 'M6 9l6 6 6-6',
  up: 'M6 15l6-6 6 6',
  right: 'M9 6l6 6-6 6',
  search: 'M10.5 4a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM16 16l4 4',
  doc: 'M6 3h9l3 3v15H6zM9 12h6M9 16h6',
  alert: 'M12 4l9 16H3zM12 10v4M12 17v.5',
  bold: 'M7 5h6a3.5 3.5 0 010 7H7zM7 12h7a3.5 3.5 0 010 7H7z',
  italic: 'M10 5h8M6 19h8M15 5L9 19',
  underline: 'M7 4v7a5 5 0 0010 0V4M5 20h14',
  strike: 'M5 12h14M16.5 7c-.6-1.3-2.2-2-4.5-2-2.3 0-4 1-4 2.8 0 1.2.8 2 2 2.4M8 17c.6 1.2 2 2 4 2 2.5 0 4.2-1 4.2-2.8 0-.6-.2-1-.5-1.4',
  color: 'M7 15l5-11 5 11M9 11h6M5 20h14',
  mark: 'M14 4l6 6-9 9H8l-3-3v-3zM4 21h8',
  code: 'M9 7l-5 5 5 5M15 7l5 5-5 5',
  quote: 'M5 9h4v5H5zM5 14c0 2-.8 3-2 4M14 9h4v5h-4zM14 14c0 2-.8 3-2 4',
  al: 'M4 6h16M4 10h10M4 14h16M4 18h10',
  ac: 'M4 6h16M7 10h10M4 14h16M7 18h10',
  ar: 'M4 6h16M10 10h10M4 14h16M10 18h10',
  ul: 'M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01',
  ol: 'M10 6h10M10 12h10M10 18h10M4 5l1.5-1v5M3.5 14h3l-3 4h3',
  indent: 'M4 6h16M12 10h8M12 14h8M4 18h16M4 9l3 3-3 3',
  outdent: 'M4 6h16M12 10h8M12 14h8M4 18h16M8 9l-3 3 3 3',
  task: 'M4 5h6v6H4zM6 8l1 1 2-2M13 8h7M4 14h6v6H4zM13 17h7',
  table: 'M4 5h16v14H4zM4 10h16M4 15h16M10 5v14M15 5v14',
  link: 'M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1',
  ext: 'M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5',
  obj: 'M7 4h10a1 1 0 011 1v15l-6-3.5L6 20V5a1 1 0 011-1z',
  key: 'M9 4a5 5 0 100 10 5 5 0 000-10zM13 13l7 7M17 17l2-2',
  lock: 'M6 11h12v9H6zM8 11V8a4 4 0 018 0v3',
  folder: 'M3 6h6l2 2h10v11H3z',
  tag: 'M3 12V4h8l10 10-8 8zM7.5 8h.01',
  pin: 'M9 4h6l-1 6 3 3H7l3-3zM12 13v8',
  archive: 'M3 5h18v4H3zM5 9v10h14V9M10 13h4',
  trash: 'M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6',
  wifioff: 'M3 3l18 18M5 10a10 10 0 015-2.5M19 10a10 10 0 00-3-2M8.5 14a5 5 0 017-.5M12 19h.01',
  sort: 'M7 4v16M3 16l4 4 4-4M17 20V4M13 8l4-4 4 4',
  filter: 'M4 5h16l-6 8v6l-4-2v-4z',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  refresh: 'M4 12a8 8 0 0114-5l2 2M20 4v5h-5M20 12a8 8 0 01-14 5l-2-2M4 20v-5h9',
  undo: 'M9 14L4 9l5-5M4 9h10a6 6 0 010 12h-3',
  redo: 'M15 14l5-5-5-5M20 9H10a6 6 0 000 12h3',
  rowadd: 'M4 5h16v6H4zM12 14v6M9 17h6',
  coladd: 'M5 4h6v16H5zM14 12h6M17 9v6',
  rowdel: 'M4 4h16v6H4zM9 17h6',
  coldel: 'M4 4h6v16H4zM14 12h6',
  hash: 'M5 9h14M5 15h14M10 4L8 20M16 4l-2 16',
  kbd: 'M3 6h18v12H3zM7 10h.01M11 10h.01M15 10h.01M7 14h10',
  slash: 'M16 4L8 20',
  merge: 'M6 4v6a6 6 0 006 6h6M6 20V10M15 13l3 3-3 3',
  info: 'M12 3a9 9 0 100 18 9 9 0 000-18zM12 11v5M12 8v.01',
  chat: 'M4 5h16v11H9l-5 4z',
  // Coque de navigation et Accueil (réf. 2a) : tracés repris de la maquette.
  home: 'M4 11l8-7 8 7v9H4z',
  grid: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
  user: 'M12 4a4 4 0 100 8 4 4 0 000-8zM4 20c0-4 4-6 8-6s8 2 8 6',
  moon: 'M20 14A8 8 0 1110 4a6.5 6.5 0 0010 10z',
  sun: 'M12 8a4 4 0 100 8 4 4 0 000-8zM12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19',
  chevleft: 'M15 6l-6 6 6 6',
  arrowright: 'M5 12h14M13 6l6 6-6 6',
  card: 'M3 6h18v12H3zM3 10h18',
  calendar: 'M4 6h16v14H4zM4 11h16M9 3v4M15 3v4',
  vaultkey: 'M12 15a4 4 0 11-8 0 4 4 0 018 0zM11 12l9-9M16 7l3 3',
  // Service Mots de passe (réf. 3a-3c) : tracés repris de la maquette Vault.
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  eyeoff: 'M17.9 17.9A10 10 0 0 1 12 19c-6 0-10-7-10-7a18 18 0 0 1 5.1-5.9M9.9 5.2A9 9 0 0 1 12 5c6 0 10 7 10 7a18 18 0 0 1-2.2 3.2M1 1l22 22M14.1 14.1a3 3 0 0 1-4.2-4.2',
  copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
  share: 'M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M16 6l-4-4-4 4M12 2v13',
  edit: 'M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
  wand: 'M15 4V2M15 16v-2M8 9h2M20 9h2M17.8 11.8 19 13M17.8 6.2 19 5M3 21l9-9M12.2 6.2 11 5',
  users: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2',
  mail: 'M3 5h18v14H3zM3 7l9 6 9-6',
  phone: 'M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2',
  wifi: 'M5 12.5a10 10 0 0 1 14 0M8.5 16a5 5 0 0 1 7 0M12 20h.01M2 9a15 15 0 0 1 20 0',
  shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  // Authentification (maquette Auth) : tracés repris du design system.
  fingerprint: 'M3.5 9.5a8.5 8.5 0 0117 0M6.5 12.5V10a5.5 5.5 0 0111 0v3c0 3 .5 5 1.5 7M9.5 20c.5-2 .5-4 .5-6.5a2 2 0 014 0c0 3 .5 5 1.5 7M12 12.5V15c0 2.5-.5 4.5-1.5 6.5M6.5 15c0 2-.3 3.5-1 5',
  alertcircle: 'M12 4a8 8 0 100 16 8 8 0 000-16zM12 8v5M12 16v.5',
  restore:'M3 12a9 9 0 1 0 3-6.7L3 8M3 3v5h5M12 7v5l3 2',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 18 }: { name: IconName; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ display: 'block', flex: 'none' }}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
